import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Divider, ListItemText, Menu, MenuItem, Typography } from '@material-ui/core';
import { PlaylistAdd } from '@material-ui/icons';
import { useStore } from "@roc/client-portal-shared/hooks";

const useStyles = makeStyles((theme) => ({
  menu: {
    borderRadius: 12,
    marginTop: theme.spacing(1),
  },
  menuItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    justifyContent: 'center',
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  menuHeader: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    fontWeight: 600,
    fontSize: '1rem',
  },
  menuSize: {
    padding: theme.spacing(2),
    width: "400px"
  }
}));

interface PresetFiltersProps {
  onApply: (preset: string) => void;
}


const FilterPreset = ({ onApply }: PresetFiltersProps) => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolFiltersStore } = compToolStore;
  const { presetOptions } = compToolFiltersStore;
  const classes = useStyles();
  const activePreset = compToolFiltersStore.activePreset;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value: string) => {
    onApply(value);
    handleClose();
  };


  return (
    <>
      <Button color="primary" variant="outlined" onClick={handleOpen}>
        <PlaylistAdd fontSize="small" />
        Presets
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        classes={{ paper: classes.menu }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        getContentAnchorEl={null}
      >
        <Box display="flex" flexDirection="column" gridGap="1rem" className={classes.menuSize}>
          <Typography className={classes.menuHeader}>Presets</Typography>
          <Divider />
          {presetOptions.map((option) => (
            <MenuItem
              selected={activePreset === option.value}
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={classes.menuItem}
              style={{
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <ListItemText primary={option.label} primaryTypographyProps={{ align: 'center' }} />
            </MenuItem>
          ))}
        </Box>
      </Menu>

    </>
  );
};

export default FilterPreset;
